<template>
	<div class="browse" :class="browse.browseType">
		<div class="header" v-if="config.browseTop">
			<browse-top class="nav-top" />
			<!-- 安卓端占位 -->
			<android-seat />
			<div class="seat posted"></div>
		</div>

		<div class="middle" @contextmenu.prevent="context_menu">
			<router-view />
		</div>

		<div class="footer"></div>
	</div>
</template>
<script lang="ts">
export default { name: 'browse' };
</script>
<script setup lang="ts">
import { config } from '@/store';
import browseTop from '@/layout/components/browse-top.vue';
import useBrowseStore from '@/store/browse';
import androidSeat from '@/layout/components/android-seat.vue';

const browse = useBrowseStore();

function context_menu() {
	config.rightSidebar = true;
}
</script>

<style scoped lang="less">
.browse {
	display: flex;
	flex-direction: column;

	.middle {
		flex: 1;
		overflow: hidden;
	}

	&.single,
	&.double,
	&.half {
		height: 100vh;
	}
}

.seat.posted {
	height: 9.6rem;
}

.nav-top {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1;
}
</style>
